import React, { useState, useEffect } from 'react';
import SocialMediaCTA from '../components/SocialMediaCTA';
import CTABanner from '../components/landingPage/CTABanner';
import NewsSection from '../components/landingPage/NewsSection';

const MachineriesPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [machineries, setMachineries] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [machineryResponse, vehiclesResponse] = await Promise.all([
          fetch(`${process.env.REACT_APP_BASE_URL_API}/api/machinery`),
          fetch(`${process.env.REACT_APP_BASE_URL_API}/api/vehicles`),
        ]);

        if (!machineryResponse.ok || !vehiclesResponse.ok) {
          throw new Error('Failed to fetch data');
        }

        const machineryData = await machineryResponse.json();
        const vehiclesData = await vehiclesResponse.json();

        setMachineries(machineryData.machinery);
        setVehicles(vehiclesData.vehicles);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const openModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  if (loading) return <div className="min-h-screen pt-40 bg-gray-100 font-poppins py-16 text-center">Loading...</div>;
  if (error) return <div className="min-h-screen pt-40 bg-gray-100 font-poppins py-16 text-center text-red-500">Error: {error}</div>;

  return (
    <div className="min-h-screen pt-40 bg-gray-100 font-poppins py-12">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-main-blue text-center mb-8 sm:mb-12">
          Our Machineries & Vehicles
        </h1>

        {/* Machineries Section */}
        <section className="mb-12 sm:mb-16">
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-8 sm:mb-12 text-center lg:text-left">
            LIST OF MACHINERIES
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8">
            {machineries.length === 0 && <p>No machinery is availbale for now. Check back later.</p>}
            {machineries.map((machine, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden group hover:shadow-xl transition-shadow duration-300">
                <img
                  src={machine.images && machine.images.length > 0 ? `http://localhost:5000${machine.images[0].imageUrl}` : 'https://via.placeholder.com/300'}
                  alt={`${machine.name}: ${machine.description}`}
                  className="w-full h-48 object-cover cursor-pointer"
                  onClick={() => openModal(machine.images && machine.images.length > 0 ? `http://localhost:5000${machine.images[0].imageUrl}` : 'https://via.placeholder.com/300')}
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-main-blue mb-2">{machine.name}</h3>
                  <p className="text-gray-700 text-base mb-2">{machine.description}</p>
                  <p className="text-gray-700 text-lg">Number: <span className="font-semibold text-black">{machine.number}</span></p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Vehicles Section */}
        <section>
          <div className="my-8 sm:my-12">
            <CTABanner />
          </div>
          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-8 sm:mb-12 text-center lg:text-left">
            LIST OF VEHICLES
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8">
            {vehicles.length === 0 && <p>No vehicle is availbale for now. Check back later.</p>}
            {vehicles.map((vehicle, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden group hover:shadow-xl transition-shadow duration-300">
                <img
                  src={vehicle.images && vehicle.images.length > 0 ? `http://localhost:5000${vehicle.images[0].imageUrl}` : 'https://via.placeholder.com/300'}
                  alt={`${vehicle.name}: ${vehicle.description}`}
                  className="w-full h-48 object-cover cursor-pointer"
                  onClick={() => openModal(vehicle.images && vehicle.images.length > 0 ? `http://localhost:5000${vehicle.images[0].imageUrl}` : 'https://via.placeholder.com/300')}
                />
                <div className="p-6">
                  <h3 className="text-xl font-bold text-main-blue mb-2">{vehicle.name}</h3>
                  <p className="text-gray-700 text-base mb-2">{vehicle.description}</p>
                  <p className="text-gray-700 text-lg">Number: <span className="font-semibold text-black">{vehicle.number}</span></p>
                </div>
              </div>
            ))}

          </div>

        </section>


        <div className="my-8 sm:my-12">
          <SocialMediaCTA />
        </div>
        <div className="my-8 sm:my-12">
          <NewsSection />
        </div>

        {isModalOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
            onClick={closeModal}
          >
            <div className="relative bg-white p-2 rounded-lg max-w-3xl max-h-full overflow-auto">
              <button
                className="absolute top-2 right-2 text-white text-2xl sm:text-3xl font-bold bg-gray-800 rounded-full w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center leading-none"
                onClick={closeModal}
              >
                &times;
              </button>
              <img src={selectedImage} alt="Full view" className="max-w-full max-h-full object-contain" />
            </div>
          </div>
        )}
      </div>

    </div >
  );
};

export default MachineriesPage;
